import React from "react";
import { useGoogleLogin } from "@react-oauth/google";
import Google from "../../../images/SocialMediaGif/google.png";

function GoogleLogin({
  outer,
  className = "m1-option-img",
  updateToken,
  title,
  errorGettingToken,
}) {
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => updateToken("google", codeResponse),
    onError: (error) => errorGettingToken("google", error),
  });
  return (
    <li
      className={
        outer
          ? "login-options-btn d-flex align-items-center"
          : "l-none d-flex align-items-center"
      }
      onClick={() => login()}
    >
      <img src={Google} alt="logo" className={className} />
      <span className="ml-3">{title}</span>
    </li>
  );
}

export default GoogleLogin;
